<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      width="625"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
           Ubah Data Profil Saya
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="reset()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="pt-2" style="height: 750px;">
          <ValidationObserver ref="form">
            <v-form>
              <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Nama Lengkap
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 70%;'"
                  dense
                  outlined
                  placeholder="Ex. John Doe"
                  color="#00ACC1"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="username" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Username
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 45%;'"
                  dense
                  outlined
                  placeholder="Ex. johndoe"
                  color="#00ACC1"
                  v-model="form.username"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Email
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 45%;'"
                  dense
                  outlined
                  placeholder="Ex. johndoe@gmail.com"
                  color="#00ACC1"
                  v-model="form.email"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="mobilephone" rules="required|min:10|max:14" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Telepon
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 50%;'"
                  type="number"
                  dense
                  outlined
                  placeholder="Ex. 081XXXXXXXXX"
                  color="#00ACC1"
                  v-model="form.mobilephone"
                  :counter="14" 
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <div>
                <p class="mb-2">
                  Alamat (bisa dikosongi)
                </p>

                <v-textarea
                  v-on:keyup.enter="save()"
                  outlined
                  dense
                  placeholder="Ex. Jl. Ahmad Yani No. 77"
                  hide-details
                  rows="3"
                  color="#00ACC1"
                  v-model="form.address">
                </v-textarea>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-col cols="12" md="3" sm="3" class="py-0">
        <v-card class="border-radius"
          :flat="rps === 'xs'" 
          :class="rps === 'xs' ? 'mb-6' : 'box-shadow pa-3'">
          <v-list flat two-line class="py-0">
            <v-list-item class="px-0">
              <v-list-item-avatar tile size="50" class="mr-3">
                <v-img 
                  style="border-radius: 10px;"
                  :src="detail.image_url !=='' ? detail.image_url : require('@/assets/image/member-default.jpg')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        color="#00ACC1">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="body-1 text-capitalize font-weight-bold mb-2">
                  {{ detail.name }}
                </v-list-item-title>

                <v-list-item-subtitle class="text-capitalize font-weight-light">
                  <span class="d-flex align-center">
                    <v-icon small>
                      {{ detail.position === 'superadmin' ? 'mdi-seal' : 'mdi-license' }}
                    </v-icon>

                    {{ detail.position }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider class="mb-3" style="border: 2px solid #f0f0f0;"/>

          <div :class="rps === 'xs' ? '' : 'px-0'">
            <p class="body-1 font-weight-bold mb-3">
              Akun Saya
            </p>

            <p class="body-2 d-flex align-center cursor-pointer mb-2"
              v-for="(item, index) in menu"
              :key="index"
              @click="selected.menu = index">
              <v-icon small class="mr-1" :color="selected.menu === index ? 'cyan darken-1' : 'grey'">
                {{ item.icon }}
              </v-icon>

              <span :class="selected.menu === index ? 'cyan--text text-darken-1' : 'grey--text'">
                {{ item.label }}
              </span>
            </p>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="9" sm="9" class="py-0">
        <v-card flat v-if="selected.menu < 1">
          <div v-if="process.load">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.load"
              type="article">
            </v-skeleton-loader>

            <v-row>
              <v-col cols="12" md="7">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.load"
                  type="article, article, article">
                </v-skeleton-loader>
              </v-col>

              <v-col cols="12" md="3">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.load"
                  type="image, article">
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </div>

          <div v-else>
            <p class="body-1 font-weight-bold mb-1">
              General Profil
            </p>

            <p>
              Anda dapat mengubah data profil anda, dibawah ini.
            </p>

            <v-divider class="mb-2" style="border: 2px solid #f0f0f0;"/>

            <v-row>
              <v-col cols="12" md="7">
                <div class="mb-3">
                  <div class="body-1 font-weight-bold d-flex align-center mb-3">
                    <div>
                      Informasi Kontak
                    </div>

                    <v-spacer />
                    
                    <div>
                      <v-btn
                        text
                        small
                        class="body-2 text-capitalize"
                        color="blue"
                        @click="reset(detail)">
                        <v-icon small class="mr-1">mdi-pencil</v-icon>
                        Ubah
                      </v-btn>
                    </div>
                  </div>

                  <div class="body-2 font-weight-light text-first d-flex align-start">
                    <div class="mb-2" :style="rps === 'xs' ? 'width: 170px;' : 'width: 200px;'">
                      Email
                    </div>
                    <div class="mb-2">
                      {{ detail.email }}
                    </div>
                  </div>

                  <div class="body-2 font-weight-light text-first d-flex align-start">
                    <div class="mb-2" :style="rps === 'xs' ? 'width: 170px;' : 'width: 200px;'">
                      Telepon
                    </div>
                    
                    <div class="mb-2">
                      {{ detail.mobilephone }}
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="body-1 font-weight-bold mb-3">
                    Informasi General
                  </div>

                  <div class="body-2 font-weight-light text-first d-flex align-start">
                    <div class="mb-2" :style="rps === 'xs' ? 'width: 170px;' : 'width: 200px;'">
                      Kode Pengguna
                    </div>
                    <div class="mb-2">
                      {{ detail.code }}
                    </div>
                  </div>

                  <div class="body-2 font-weight-light text-first d-flex align-start">
                    <div class="mb-2" :style="rps === 'xs' ? 'width: 170px;' : 'width: 200px;'">
                      Role (Posisi)
                    </div>
                    <div class="text-capitalize mb-2">
                      {{ detail.role }} ({{ detail.position }})
                    </div>
                  </div>
                  
                  <div class="body-2 font-weight-light text-first d-flex align-start">
                    <div class="mb-2" :style="rps === 'xs' ? 'width: 170px;' : 'width: 200px;'">
                      Status
                    </div>
                    <div class="text-capitalize mb-2"
                      :class="detail.active_bool ? 'cyan--text text-darken-1' : ''">
                      {{ detail.active_bool ? 'Aktif' : 'Tidak Aktif' }}
                    </div>
                  </div>

                  <div class="body-2 font-weight-light text-first d-flex align-start">
                    <div class="mb-2" :style="rps === 'xs' ? 'width: 170px;' : 'width: 200px;'">
                      Alamat
                    </div>
                    <div class="text-capitalize mb-2">
                      {{ detail.address === '' ? '-' : detail.address }}
                    </div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="3" class="text-center">
                <v-card class="border-radius pa-5"
                  :flat="rps === 'xs'" 
                  :class="rps === 'xs' ? '' : 'box-shadow'">
                  <div class="mb-10">
                    <ValidationObserver ref="form">
                      <v-form>
                        <uploadimage v-model="images" style="width: 100%; height: 200px;">
                          <div slot="activator">
                            <v-avatar 
                              tile
                              size="225" 
                              color="white" 
                              style="border-radius: 20px !important;"
                              class="cursor-pointer" 
                              v-ripple>
                              <v-progress-circular v-if="process.image"
                                indeterminate
                                color="#00ACC1">
                              </v-progress-circular>

                              <v-img v-else
                                :src="form.image_url !== '' ? form.image_url : detail.image_url !== '' ? detail.image_url : require('@/assets/image/member-default.jpg')" 
                                gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                                alt="VENOM">
                                <v-icon size="50" color="white">mdi-camera</v-icon>
                              </v-img>
                            </v-avatar>
                          </div>
                        </uploadimage>
                      </v-form>
                    </ValidationObserver>
                  </div>

                  <div class="caption font-italic font-weight-light text-second text-center">
                    Maksimal ukuran gambar 5MB, dengan ekstensi gambar .JPG/.JPEG/.PNG
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-card>

        <v-card flat v-else>
          <p class="body-1 font-weight-bold mb-1">
            Ubah Password
          </p>

          <p>
            Anda dapat mengubah password profil anda, dibawah ini.
          </p>

          <v-divider class="mb-2" style="border: 2px solid #f0f0f0;"/>

          <v-row>
            <v-col cols="12" md="4">
              <ValidationObserver ref="form">
                <v-form>
                  <ValidationProvider name="password_old" rules="required|min:5|max:20" v-slot="{ errors }">
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Password Lama
                    </p>
                    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      outlined
                      dense 
                      color="#00ACC1"
                      placeholder="Password Lama"
                      prepend-inner-icon="mdi-form-textbox-password"
                      v-model="form.password_old"
                      :type="show.password_old ? 'text' : 'password'"
                      :append-icon="show.password_old ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show.password_old = !show.password_old"
                      :counter="20"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider name="password_new" rules="required|min:5|max:20" v-slot="{ errors }">
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Password Baru
                    </p>
                    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      outlined
                      dense 
                      color="#00ACC1"
                      placeholder="Password Baru"
                      prepend-inner-icon="mdi-form-textbox-password"
                      v-model="form.password_new"
                      :type="show.password_new ? 'text' : 'password'"
                      :append-icon="show.password_new ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show.password_new = !show.password_new"
                      :counter="20"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <v-alert v-if="message.error.length > 0"
                type="error" 
                dense
                text 
                prominent>
                {{ message.error }}
              </v-alert>

              <v-btn
                color="#00ACC1"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text"
                :disabled="process.form"
                :loading="process.form"
                v-on:keyup.enter="save()"
                @click="save()">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import { TokenService } from "../../../service/Storage.Service";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          snackbar: false
        },
        selected: {
          menu: 0
        },
        menu: [
          {
            label: 'Profil Saya',
            icon: 'mdi-account-reactivate-outline',
            link: '/dashboard?menu=profile'
          },
          {
            label: 'Password',
            icon: 'mdi-shield-key-outline',
            link: '/dashboard?menu=password'
          }
        ],
        detail: {},
        images: '',
        show: {
          password_old: false,
          password_new: false
        },
        form: {
          name: '',
          username: '',
          email: '',
          mobilephone: '',
          address: '',
          image_url: '',

          // PASSWORD
          password_old: '',
          password_new: ''
        },
        process: {
          load: false,
          image: false,
          form: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/uploadimage.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      'images': {
        handler: function () {
          if (this.images) {
            this.process.image = this.images.process 
            
            if (!this.process.image) this.form.image_url = this.images.fileuri
          }

          if (this.images) {
            this.process.image = this.images.process 

            if (!this.process.image) {
              this.form.image_url = this.images ? this.images.fileuri : ''

              if (this.form.image !== '') {
                this.save()
              }
            }
          }
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch() {
        this.process.load = true

        await get(`admin/profile`).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data

            TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(this.detail),
              JSON.stringify(this.$store.state.menu)
            )
          }
        })
      },
      reset(item) {
        if (this.$refs.form) this.$refs.form.reset()

        if (this.form.image_url.length < 1 && this.form.password_new.length < 1) this.dialog.form = !this.dialog.form ? true : false

        this.form = {
          name: item === undefined ? '' : item.name,
          username: item === undefined ? '' : item.username,
          email: item === undefined ? '' : item.email,
          mobilephone: item === undefined ? '' : item.mobilephone,
          address: item === undefined ? '' : item.address,
          image_url: '',

          // PASSWORD
          password_old: '',
          password_new: ''
        }

        this.process.form = false

        this.message.error = ''
      },
      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let url = this.form.image_url.length > 0 ? `admin/profile/update_image` : 
                    this.form.password_new.length > 0 ? `admin/profile/update_password` : `admin/profile/update`
          
          this.process.form = true
          
          await post(url, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.$store.state.user.image_url = this.form.image_url.length > 0 ? this.form.image_url : this.$store.state.user.image_url

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>